/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: inherit
 */
import React from 'react';
import { type ViewStyle } from 'react-native';
import { DenseListCard } from '../../../shared/surface-cards/DenseListCard';

type Props = {
  children: React.ReactNode;
  bodyStyle?: ViewStyle;
  wrapStyle?: ViewStyle;
};

/** Tarjeta de listado densa (re-export del shell compartido). */
export function ReportsDenseListCard({ children, bodyStyle, wrapStyle }: Props) {
  return (
    <DenseListCard bodyStyle={bodyStyle} wrapStyle={wrapStyle} accentTone="neutral">
      {children}
    </DenseListCard>
  );
}
